<section id="content">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>Informative</h2>

      <div class="page-bar">
        Informative Page
        
      </div>

    </div>

  </div>

</section>

